import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'pt-details-image',
  template: `
    <div class='circle'>
      <span class='initials'>{{initial}}</span>
    </div>
  `,
  styles: [
    `
      .circle {
        border: 2px solid #737373;
        background: #fff;
        position: absolute;
        top: 20px;
        left: 25px;
        width: 60px;
        height: 60px;
        text-align: center;
        border-radius: 50%;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
      }

      .initials {
        position: relative;
        top: 18px; /* 25% of parent */
        font-size: 25px; /* 50% of parent */
        line-height: 25px; /* 50% of parent */
        color: #494949;
        font-family: "Courier New", monospace;
        font-weight: bold;
      }
    `
  ]
})
export class DetailsImageComponent implements OnInit {
  public initial: string;

  ngOnInit(): void {
    this.initial = this.extractInitial();
  }

  private extractInitial() {
    const u = window.location.pathname.split('/').pop();
    if (u.length > 0) {
      return u.split('-').map(t => t.substring(0, 1).toUpperCase()).join('');
    }
  }
}
